import React from "react";

export const OrnamentDivider = ({ className = "", label }) => (
  <div
    className={`flex items-center gap-3 ${className}`}
    data-testid="ornament-divider"
    aria-hidden={!label}
  >
    <div className="ornament-line flex-1" />
    {label ? (
      <span className="eyebrow whitespace-nowrap">{label}</span>
    ) : (
      <span className="h-1.5 w-1.5 rotate-45 bg-[color:var(--gild)]" />
    )}
    <div className="ornament-line flex-1" />
  </div>
);

export default OrnamentDivider;
